(function () {
  const form    = document.querySelector('[data-tea-search]');
  if (!form) return;
  const input   = form.querySelector('input[type="search"]');
  const dropEl  = form.querySelector('[data-tea-predictive]');
  const innerEl = dropEl.querySelector('.tea-predictive__inner');

  let debounceTimer;
  let activeRequest;

  function show()   { dropEl.hidden = false; }
  function hide()   { dropEl.hidden = true; }
  function loading() {
    innerEl.innerHTML = '<div class="tea-predictive__loading">Searching…</div>';
    show();
  }

  function money(cents, format) {
    // Falls back to Shopify money format if provided
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents, format || (window.theme && window.theme.moneyFormat) || '${{amount}}')
      : 'R' + (cents / 100).toFixed(2);
  }

  async function run(query) {
    if (activeRequest) activeRequest.abort();
    const ctrl = new AbortController();
    activeRequest = ctrl;

    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;

    try {
      const res = await fetch(url, { signal: ctrl.signal });
      const data = await res.json();
      render(data.resources && data.resources.results, query);
    } catch (err) {
      if (err.name !== 'AbortError') hide();
    }
  }

  function render(results, query) {
    const products = (results && results.products) || [];
    if (!products.length) {
      innerEl.innerHTML = `<div class="tea-predictive__empty">No quick matches. Press Enter to search anyway.</div>`;
      show();
      return;
    }

    let html = `<div class="tea-predictive__group-label">Products</div>`;
    products.forEach(p => {
      const img = p.featured_image && p.featured_image.url
        ? `<img class="tea-predictive__thumb" src="${p.featured_image.url}&width=120" alt="" loading="lazy">`
        : `<div class="tea-predictive__thumb"></div>`;
      const price = p.price ? `<div class="tea-predictive__price">${money(p.price * 100)}</div>` : '';
      html += `
        <a class="tea-predictive__item" href="${p.url}">
          ${img}
          <div class="tea-predictive__info">
            <div class="tea-predictive__title">${p.title}</div>
            ${price}
          </div>
        </a>`;
    });
    html += `<a class="tea-predictive__view-all" href="/search?q=${encodeURIComponent(query)}&type=product">View all results →</a>`;

    innerEl.innerHTML = html;
    show();
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debounceTimer);
    if (q.length < 2) { hide(); return; }
    debounceTimer = setTimeout(() => { loading(); run(q); }, 180);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && innerEl.innerHTML) show();
  });

  document.addEventListener('click', (e) => {
    if (!form.contains(e.target)) hide();
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { hide(); input.blur(); }
  });
})();